import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Row, Col, Modal, notification } from "antd";
import { getVehiclesTypes, updateVehiclesType } from "../../../api/vehicles-type.service";
import { updateVehicle } from "../../../api/vehicles.service";

const EditVehicleFormModal = ({ fetchAllVehicles, vehicleData, onClose, isModalOpen, setIsModalOpen, handleOk, handleCancel, isViewOnly = false }) => {
    const [form] = Form.useForm();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                registrationNo: vehicleData.registrationNo,
                vehicleTypeId: vehicleData.vehicleType?.id || undefined,
                make: vehicleData?.make || "",
                model: vehicleData?.model || "",
                color: vehicleData?.color || ""
            });
        } else {
            form.resetFields();
        }
    }, [vehicleData, form]);

    const onFinish = async (values) => {
        try {
            await updateVehicle(vehicleData.id, { ...values });
            notification.success({ message: "Vehicle Edited" });
            fetchAllVehicles();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    const fetchVehicles = async () => {
        try {
            const response = await getVehiclesTypes();
            setOptions(
                response?.data?.map((elem) => ({
                    value: elem.id,
                    label: elem.name,
                })) || []
            );
        } catch (err) {
            notification.error({ message: "Failed to fetch vehicle types" });
        }
    };

    useEffect(() => {
        fetchVehicles();
    }, []);

    return (
        <Modal 
            footer={null} 
            destroyOnClose 
            title={`${isViewOnly ? "View" : "Edit"} Vehicle`} 
            open={isModalOpen} 
            onCancel={handleCancel}
        >
            <Form
                disabled={isViewOnly}
                form={form}
                layout="vertical"
                onFinish={onFinish} 
                initialValues={{ 
                    registrationNo: "", 
                    vehicleTypeId: "",
                    make: "",
                    model: "",
                    color: ""
                }}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item 
                            label="Vehicle reg no" 
                            name="registrationNo" 
                            rules={[{ required: true, message: "Please enter vehicle registration number" }]}
                        >
                            <Input placeholder="Enter registration number" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item 
                            label="Vehicle Type" 
                            name="vehicleTypeId" 
                            rules={[{ required: true, message: "Please select vehicle type" }]}
                        >
                            <Select 
                                className='vt-sel'
                                placeholder="Select vehicle type" 
                                options={options}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item 
                            label="Make" 
                            name="make"
                            rules={[{ required: true, message: "Please enter vehicle make" }]}
                        >
                            <Input placeholder="Enter vehicle make" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item 
                            label="Model" 
                            name="model"
                            rules={[{ required: true, message: "Please enter vehicle model" }]}
                        >
                            <Input placeholder="Enter vehicle model" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item 
                            label="Color" 
                            name="color"
                            rules={[{ required: true, message: "Please enter vehicle color" }]}
                        >
                            <Input placeholder="Enter vehicle color" />
                        </Form.Item>
                    </Col>
                </Row>
                {!isViewOnly && (
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
};

export default EditVehicleFormModal;
